import React from 'react';
import { Card, CardBody, Col, FormGroup, Input, Label, Row } from 'reactstrap';

interface TransferSectionProps {
    values: {
        startingAddress: string;
        startDate: string;
        endDate: string;
        plate: string;
    };
    touched: {
        startingAddress?: boolean;
        startDate?: boolean;
        endDate?: boolean;
        plate?: boolean;
    };
    errors: {
        startingAddress?: string;
        startDate?: string;
        endDate?: string;
        plate?: string;
    };
    onChange: (field: string, value: any) => void;
}

const TransferSection: React.FC<TransferSectionProps> = ({
    values,
    touched,
    errors,
    onChange
}) => {
    const handleInputChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(field, e.target.value);
    };

    return (
        <Card className="shadow border-0 h-100 overflow-hidden rounded-3">
            <div className="bg-soft-primary p-3 border-bottom border-light">
                <h5 className="card-title mb-0 text-primary fw-semibold d-flex align-items-center">
                    <i className="ri-route-line me-2 fs-18"></i>
                    Información del Traslado
                </h5>
            </div>
            <CardBody className="p-4 bg-white">
                <Row className="g-3">
                    <Col md={12}>
                        <FormGroup className="mb-0">
                            <Label className="form-label text-muted fw-medium small text-uppercase">
                                Dirección de partida <span className="text-danger">*</span>
                            </Label>
                            <div className="input-group">
                                <span className="input-group-text bg-light border-end-0">
                                    <i className="ri-map-pin-line text-muted"></i>
                                </span>
                                <Input
                                    name="startingAddress"
                                    className="form-control border-start-0 ps-1"
                                    value={values.startingAddress}
                                    onChange={handleInputChange('startingAddress')}
                                    invalid={!!(touched.startingAddress && errors.startingAddress)}
                                    placeholder="Dirección de origen"
                                />
                                {touched.startingAddress && errors.startingAddress && (
                                    <div className="invalid-feedback">{errors.startingAddress}</div>
                                )}
                            </div>
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup className="mb-0">
                            <Label className="form-label text-muted fw-medium small text-uppercase">
                                Inicio de transporte <span className="text-danger">*</span>
                            </Label>
                            <div className="input-group">
                                <span className="input-group-text bg-light border-end-0">
                                    <i className="ri-calendar-line text-muted"></i>
                                </span>
                                <Input
                                    type="date"
                                    name="startDate"
                                    className="form-control border-start-0 ps-1"
                                    value={values.startDate}
                                    onChange={handleInputChange('startDate')}
                                    invalid={!!(touched.startDate && errors.startDate)}
                                />
                                {touched.startDate && errors.startDate && (
                                    <div className="invalid-feedback">{errors.startDate}</div>
                                )}
                            </div>
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup className="mb-0">
                            <div className="d-flex align-items-center gap-2 mb-2">
                                <Label className={`form-label small text-uppercase mb-0 ${!values.endDate && !(touched.endDate && errors.endDate) ? 'text-warning' : 'text-muted'}`}>
                                    Fin de transporte <span className="text-danger">*</span>
                                </Label>
                            </div>
                            <div
                                className="input-group"
                                style={!values.endDate && !(touched.endDate && errors.endDate) ? {
                                    borderRadius: '0.375rem',
                                    boxShadow: '0 0 0 2px #ffc10780',
                                    animation: 'pulse-warning 1.5s ease-in-out infinite'
                                } : {}}
                            >
                                <span className={`input-group-text border-end-0 ${!values.endDate && !(touched.endDate && errors.endDate) ? 'bg-warning bg-opacity-10 border-warning' : 'bg-light'}`}>
                                    <i className={`ri-calendar-check-line ${!values.endDate && !(touched.endDate && errors.endDate) ? 'text-warning' : 'text-muted'}`}></i>
                                </span>
                                <Input
                                    type="date"
                                    name="endDate"
                                    className={`form-control border-start-0 ps-1 ${!values.endDate && !(touched.endDate && errors.endDate) ? 'border-warning' : ''}`}
                                    value={values.endDate}
                                    onChange={handleInputChange('endDate')}
                                    invalid={!!(touched.endDate && errors.endDate)}
                                />
                                {touched.endDate && errors.endDate && (
                                    <div className="invalid-feedback">{errors.endDate}</div>
                                )}
                            </div>
                        </FormGroup>
                    </Col>
                    <Col md={12}>
                        <FormGroup className="mb-0">
                            <Label className="form-label text-muted fw-medium small text-uppercase">
                                Placa <span className="text-danger">*</span>
                            </Label>
                            <div className="input-group">
                                <span className="input-group-text bg-light border-end-0">
                                    <i className="ri-car-line text-muted"></i>
                                </span>
                                <Input
                                    name="plate"
                                    className="form-control border-start-0 ps-1"
                                    value={values.plate}
                                    onChange={handleInputChange('plate')}
                                    invalid={!!(touched.plate && errors.plate)}
                                    placeholder="ABC-1234"
                                />
                                {touched.plate && errors.plate && (
                                    <div className="invalid-feedback">{errors.plate}</div>
                                )}
                            </div>
                        </FormGroup>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
};

export default TransferSection;
